import config from '@/config'
import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    meta: {
      id: 0,
      group: config.groups.PUBLIC
    },
    profile: {}
  },

  mutations: {
    /**
     * Reset user state
     * @param {Object} state vuex state
     */
    reset (state) {
      state.meta = {
        id: 0,
        group: config.groups.PUBLIC
      }

      state.profile = {}
    },
    /**
     * Set user meta data
     * @param {Object} state vuex state
     * @param {Object} data Meta data
     */
    meta (state, data) {
      Vue.set(state, 'meta', data)
    },
    /**
     * Set user profile data
     * @param {Object} state vuex state
     * @param {Object} data Profile data
     */
    profile (state, data) {
      Vue.set(state, 'profile', data)
    }
  }
}
